function resolveComponentProps(componentProps, ownerState, slotState) {
  return typeof componentProps == "function" ? componentProps(ownerState, slotState) : componentProps;
}
export {
  resolveComponentProps
};
//# sourceMappingURL=resolveComponentProps.js.map
